import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { assertDefined } from '@dynamic-labs-sdk/client/core';
import { ProviderEnum } from '@dynamic-labs/sdk-api-core';

export const getZerodevProviderFromSettings = (client: DynamicClient) => {
  const projectSettings = client.projectSettings;

  assertDefined(projectSettings, 'Project settings are not available');

  const zerodevProvider = projectSettings.providers?.find(
    (provider) => provider.provider === ProviderEnum.Zerodev
  );

  assertDefined(
    zerodevProvider,
    'Zerodev is not configured in project settings'
  );

  return zerodevProvider;
};
